/* Mobile menu hardening (v2). Everything is delegated from document, and the only state lives on
   <html>, because the theme re-renders the header section (add to cart, cart open) and replaces
   the header's DOM nodes, wiping classes/listeners set on them. Without this file the native
   <details> behaviour still works. */
(function () {
  if (window.__kmDrawerFix) return;
  window.__kmDrawerFix = true;
  var root = document.documentElement;

  function drawer() { return document.querySelector('[data-km-drawer]'); }
  function place() {
    var h = document.querySelector('.km-header');
    if (!h) return;
    root.style.setProperty('--km-drawer-top', Math.max(0, Math.round(h.getBoundingClientRect().bottom)) + 'px');
  }
  function sync() {
    var d = drawer();
    if (!d) return;
    var s = d.querySelector('summary');
    if (s) s.setAttribute('aria-expanded', d.open ? 'true' : 'false');
    if (d.open) place();
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var s = t.closest('[data-km-drawer] > summary');
    if (s) {
      e.preventDefault();
      var d = s.parentNode;
      place();
      d.open = !d.open;
      sync();
      return;
    }
    var open = t.closest('[data-km-drawer]');
    if (open && open.open && t.closest('a')) { open.open = false; sync(); }
  }, true);

  document.addEventListener('keydown', function (e) {
    var d = drawer();
    if (e.key === 'Escape' && d && d.open) {
      d.open = false;
      sync();
      var s = d.querySelector('summary');
      if (s) s.focus();
    }
  });
  document.addEventListener('toggle', sync, true);
  window.addEventListener('resize', function () {
    var d = drawer();
    if (d && d.open) { if (window.innerWidth >= 1024) { d.open = false; sync(); } else place(); }
  }, { passive: true });
  window.addEventListener('scroll', function () {
    var d = drawer();
    if (d && d.open) place();
  }, { passive: true });
  document.addEventListener('shopify:section:load', sync);
  sync();
})();
